import { RequestTypeDetailQuery } from 'generated/resources/graphql'

interface GetFeatureFlagsResult {
  isProcurementV2FeatureEnabled: boolean
  isCompleteFormEnabled: boolean
  isVendorOnboardingEnabled: boolean
}

export function getFeatureFlags(data?: RequestTypeDetailQuery): GetFeatureFlagsResult {
  const features = data?.features?.featuresConnection?.edges?.map((e) => e.node) ?? []

  const isProcurementV2FeatureEnabled = features.some(
    (f) => f.name === 'procurement_v2' && f.enabled
  )

  const isCompleteFormEnabled = features.some(
    (f) => f.name === 'dev_procurement_v2_complete_form' && f.enabled
  )

  const isVendorOnboardingEnabled = features.some(
    (f) => f.name === 'dev_procurement_vendor_onboarding' && f.enabled
  )

  return { isProcurementV2FeatureEnabled, isCompleteFormEnabled, isVendorOnboardingEnabled }
}
